import React, { useState } from 'react';
import { 
    Table, 
    Button, 
    Card, 
    Space, 
    Modal, 
    Form, 
    Input, 
    message, 
    Popconfirm,
    Typography,
    Tag,
    Tooltip
} from 'antd';
import { 
    PlusOutlined, 
    EditOutlined, 
    DeleteOutlined,
    SafetyOutlined,
    TeamOutlined,
    FileTextOutlined
} from '@ant-design/icons';

const { Title, Text, Link } = Typography;

const VendorDefinition = () => {
    // 文档地址状态
    const [docUrl, setDocUrl] = useState('https://my.feishu.cn/docx/VndXdx4OBoX7MkxR6yZcWfPsnof');
    const [docModalVisible, setDocModalVisible] = useState(false);
    const [docForm] = Form.useForm();

    // 初始模拟数据
    const [data, setData] = useState([
        { 
            id: '1', 
            name: '麦联宝', 
            enterpriseCount: 3, 
            enterprises: [
                { id: 'E1001', name: '捷顺科技' },
                { id: 'E1002', name: '万科物业' },
                { id: 'E1003', name: '康林物联网' },
            ],
            createdAt: '2024-01-01 10:00:00' 
        },
        { 
            id: '2', 
            name: '万物互联电信(zweitx)', 
            enterpriseCount: 1, 
            enterprises: [
                { id: 'E2001', name: '电信智慧家庭' },
            ],
            createdAt: '2024-01-02 11:30:00' 
        },
        { id: '3', name: '桔子智联', enterpriseCount: 0, enterprises: [], createdAt: '2024-01-05 09:20:00' },
        { id: '4', name: '信丰驰维', enterpriseCount: 2, enterprises: [{ id: 'E4001', name: '信丰物流' }, { id: 'E4002', name: '驰维电子' }], createdAt: '2024-01-10 14:45:00' },
        { id: '5', name: '五兴科技', enterpriseCount: 0, enterprises: [], createdAt: '2024-01-15 16:10:00' },
        { id: '6', name: '天贝云客猫', enterpriseCount: 1, enterprises: [{ id: 'E6001', name: '云客科技' }], createdAt: '2024-01-20 12:00:00' },
    ]);

    const [modalVisible, setModalVisible] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [entListVisible, setEntListVisible] = useState(false);
    const [currentEnts, setCurrentEnts] = useState([]);
    const [currentVendorName, setCurrentVendorName] = useState('');
    const [form] = Form.useForm();

    const handleAddOrEdit = (record = null) => {
        setEditingItem(record);
        if (record) {
            form.setFieldsValue(record);
        } else {
            form.resetFields();
        }
        setModalVisible(true);
    };

    const showEnterpriseList = (record) => {
        setCurrentVendorName(record.name);
        setCurrentEnts(record.enterprises || []);
        setEntListVisible(true);
    };

    const handleDelete = (id) => {
        setData(data.filter(item => item.id !== id));
        message.success('删除成功');
    };

    const handleOk = () => {
        form.validateFields().then(values => {
            if (editingItem) {
                setData(data.map(item => item.id === editingItem.id ? { ...item, ...values } : item));
                message.success('修改成功');
            } else {
                const newItem = {
                    id: Date.now().toString(),
                    name: values.name,
                    enterpriseCount: 0,
                    enterprises: [],
                    createdAt: new Date().toLocaleString(),
                };
                setData([...data, newItem]);
                message.success('新增成功');
            }
            setModalVisible(false);
        });
    };

    // 保存文档地址
    const handleSaveDoc = () => {
        docForm.validateFields().then(values => {
            setDocUrl(values.url);
            message.success('文档地址已更新');
            setDocModalVisible(false);
        });
    };

    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
            key: 'id',
            width: 70,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: '卡商名称',
            dataIndex: 'name',
            key: 'name',
            render: (text) => (
                <Space>
                    <SafetyOutlined style={{ color: '#1890ff' }} />
                    <span style={{ fontWeight: 500 }}>{text}</span>
                </Space>
            ),
        },
        {
            title: '对接企业数',
            dataIndex: 'enterpriseCount',
            key: 'enterpriseCount',
            width: 120,
            align: 'center',
            render: (count, record) => (
                <Button 
                    type="link"
                    onClick={() => showEnterpriseList(record)}
                    style={{ 
                        color: count > 0 ? '#1890ff' : '#bfbfbf', 
                        fontWeight: 'bold',
                        cursor: count > 0 ? 'pointer' : 'default',
                        padding: 0
                    }}
                >
                    {count}
                </Button>
            )
        },
        {
            title: '创建时间',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 180,
        },
        {
            title: '操作',
            key: 'action',
            width: 150,
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    <Button type="link" size="small" icon={<EditOutlined />} onClick={() => handleAddOrEdit(record)}>编辑</Button>
                    <Popconfirm 
                        title="确定要删除该卡商定义吗？" 
                        onConfirm={() => handleDelete(record.id)}
                        okButtonProps={{ danger: true }}
                    >
                        <Button type="link" size="small" danger icon={<DeleteOutlined />}>删除</Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const entColumns = [
        { title: '企业名称', dataIndex: 'name', key: 'name' },
        { title: '企业 ID', dataIndex: 'id', key: 'id', render: (id) => <Tag color="blue">{id}</Tag> },
    ];

    return (
        <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>卡商定义</Title>
      </div>
            <Card 
                title={
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '24px' }}>
                        <Space>
                            <SafetyOutlined />
                            <span>卡商定义管理</span>
                        </Space>
                        <div style={{ fontSize: '13px', fontWeight: 'normal', color: '#8c8c8c', display: 'flex', alignItems: 'center' }}>
                            <FileTextOutlined style={{ marginRight: 6 }} />
                            <span>API地址：</span>
                            {docUrl ? (
                                <Link href={docUrl} target="_blank" ellipsis style={{ maxWidth: 300 }}>
                                    {docUrl}
                                </Link>
                            ) : (
                                <Text type="secondary">未设置</Text>
                            )}
                            <Tooltip title="编辑文档地址">
                                <Button 
                                    type="link" 
                                    size="small" 
                                    icon={<EditOutlined />} 
                                    onClick={() => {
                                        docForm.setFieldsValue({ url: docUrl });
                                        setDocModalVisible(true);
                                    }}
                                    style={{ marginLeft: 4 }}
                                />
                            </Tooltip>
                        </div>
                    </div>
                }
                extra={<Button type="primary" icon={<PlusOutlined />} onClick={() => handleAddOrEdit()}>定义新卡商</Button>}
                style={{ borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}
            >
                <Table columns={columns} dataSource={data} rowKey="id" pagination={{ pageSize: 10 }} />
            </Card>

            {/* 编辑/新增 卡商 Modal */}
            <Modal
                title={editingItem ? '编辑卡商' : '新增卡商定义'}
                open={modalVisible}
                onOk={handleOk}
                onCancel={() => setModalVisible(false)}
                destroyOnClose
                centered
            >
                <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
                    <Form.Item name="name" label="卡商名称" rules={[{ required: true, message: '请输入卡商名称' }]}>
                        <Input placeholder="请输入卡商名称" maxLength={50} showCount />
                    </Form.Item>
                </Form>
            </Modal>

            {/* 编辑文档地址 Modal */}
            <Modal
                title={
                    <Space>
                        <EditOutlined />
                        <span>编辑文档地址</span>
                    </Space>
                }
                open={docModalVisible}
                onOk={handleSaveDoc}
                onCancel={() => setDocModalVisible(false)}
                destroyOnClose
                centered
            >
                <Form form={docForm} layout="vertical" style={{ marginTop: 16 }}>
                    <Form.Item 
                        name="url" 
                        label="文档链接" 
                        rules={[
                            { required: true, message: '请输入文档地址' },
                            { type: 'url', message: '请输入有效的 URL 地址' }
                        ]}
                    >
                        <Input.TextArea placeholder="请输入飞书或项目文档链接" rows={3} />
                    </Form.Item>
                </Form>
            </Modal>

            {/* 企业列表 Modal */}
            <Modal
                title={
                    <Space>
                        <TeamOutlined style={{ color: '#1890ff' }} />
                        <span>{currentVendorName} - 对接企业列表</span>
                    </Space>
                }
                open={entListVisible}
                onCancel={() => setEntListVisible(false)}
                footer={[<Button key="close" onClick={() => setEntListVisible(false)}>关闭</Button>]}
                width={600}
                centered
            >
                <Table 
                    columns={entColumns} 
                    dataSource={currentEnts} 
                    rowKey="id" 
                    size="small" 
                    pagination={false}
                    locale={{ emptyText: '该卡商暂未对接任何企业' }}
                />
            </Modal>
        </div>
    );
};

export default VendorDefinition;
